import { useEffect } from 'react';
import useFeatureFlagsStore from '@/store/FeatureFlagsStore';

export interface FeatureFlags {
  relevanceSearch: boolean;
  inBranchAppointments: boolean;
}

const useFeatureFlags = (): FeatureFlags => {
  const setFeatureFlags = useFeatureFlagsStore(
    (state) => state.setFeatureFlags,
  );
  const featureFlags = useFeatureFlagsStore((state) => state.featureFlags);

  useEffect(() => {
    //TODO clean the below code once relevancesearch is live and stable in prod
    // const searchParams = new URLSearchParams(window.location.search);

    // const relevanceSearchParam = searchParams.get('relevanceSearch');
    // const enableRelevanceSearch = relevanceSearchParam === 'true';

    setFeatureFlags({
      relevanceSearch: true,
      inBranchAppointments: true,
    });
  }, [setFeatureFlags]);

  return featureFlags;
};

export default useFeatureFlags;
